import React, {Component} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import Card from "@irati/ui/src/experimental/Card"
import {H3} from "@irati/ui/src/Typography"
import {Hr} from "@irati/ui/src/Layout"
import Loading from "@irati/ui/src/Loading"
import {WellnessMedia} from "@irati/types"
import wellnessService from "@irati/wellness/services/Wellness"

import RelatedMedia from "./RelatedMedia"

interface Props {
  media: WellnessMedia
  marginTop: number
}
interface State {
  mediaId?: string
  mediaList?: WellnessMedia[]
}

class RelatedMediaList extends Component<Props, State> {
  state: State = {}

  componentDidMount() {
    this.getRelatedMedia()
  }

  componentDidUpdate() {
    this.getRelatedMedia()
  }
  getRelatedMedia = () => {
    const {media} = this.props
    const {mediaId} = this.state

    // re-fetch new related media just if we're browsing a different media (avoid infinte loop)
    if (media?.uuid !== mediaId) {
      wellnessService.getRelatedMediaList(media.uuid).then((mediaList) => {
        this.setState({mediaList, mediaId: media.uuid})
      })
    }
  }

  render() {
    const {mediaList, mediaId} = this.state
    const {media, marginTop} = this.props

    const loading = media?.uuid !== mediaId

    return (
      <Card marginTop={marginTop} padding={[4, 3]}>
        <H3>
          <FormattedMessage id="wellness.videoRecommendations.title" />
        </H3>
        <Hr />
        <Loading isLoading={loading}>{mediaList?.map((m, key) => m.uuid !== mediaId && <RelatedMedia media={m} key={key} />)}</Loading>
      </Card>
    )
  }
}

export default RelatedMediaList
